const DEFAULT_IMAGE =
  "https://s3.amazonaws.com/dev-etr/images/defaults/ETR%2BLogo.png"

const PRODUCT_INGESTION_STATUS = Object.freeze({
  RUNNING: 0,
  COMPLETE: 1,
  ERROR: 2,
})

export { DEFAULT_IMAGE, PRODUCT_INGESTION_STATUS }
